module.exports = __webpack_public_path__ + "static/Kaizen_PTVI_Electric-89010f1830a2dedaf3a223473b7f47d4.jpg";